import { SearchRegexQueryParserErrorCode } from './parser';

type RegexpQueryErrorTextPart = {
  type: 'text';
  value: string;
};

type RegexpQueryErrorSnippetPart = {
  type: 'snippet';
  value: string;
};

export type RegexpQueryErrorPart = RegexpQueryErrorTextPart | RegexpQueryErrorSnippetPart;

export type RegexpQueryErrorDescriptor = {
  parts: RegexpQueryErrorPart[];
};

export function getRegexpQueryErrorDescriptor(
  errorCode?: SearchRegexQueryParserErrorCode,
): RegexpQueryErrorDescriptor | undefined {
  if (errorCode === SearchRegexQueryParserErrorCode.MISSING_CLOSING_PAREN) {
    return {
      parts: [{ type: 'text', value: 'The query is missing a closing parenthesis.' }],
    };
  }

  if (errorCode === SearchRegexQueryParserErrorCode.UNEXPECTED_CLOSING_PAREN) {
    return {
      parts: [{ type: 'text', value: 'The query contains an unexpected closing parenthesis.' }],
    };
  }

  if (errorCode === SearchRegexQueryParserErrorCode.MALFORMED_QUERY) {
    return {
      parts: [
        {
          type: 'text',
          value:
            'The query is malformed. Use spaces only together with operators. Or, to match a literal space, use ',
        },
        { type: 'snippet', value: '\\x20' },
        { type: 'text', value: '. Example: ' },
        { type: 'snippet', value: 'my\\x20spacious\\x20string' },
        { type: 'text', value: '.' },
      ],
    };
  }

  if (errorCode === SearchRegexQueryParserErrorCode.PARTIAL_QUERY) {
    return {
      parts: [{ type: 'text', value: "The query can't end with an operator." }],
    };
  }

  if (errorCode === SearchRegexQueryParserErrorCode.QUERY_CONTAINS_INVALID_REGEXP) {
    return {
      parts: [{ type: 'text', value: 'The query contains an invalid regular expression.' }],
    };
  }

  return undefined;
}
